import {Component, inject, input, OnInit, output, signal} from '@angular/core';
import {RouterLink, RouterLinkActive} from "@angular/router";
import {NgClass, NgOptimizedImage} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {TAccountAction, TMenu} from "./menu.types";
import {AccountService} from "../../../services/account/account.service";
import {openLogoutDialog} from "../../../components/logout-dialog/logout-dialog.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
    selector: 'app-nav-list',
    imports: [
        RouterLink,
        RouterLinkActive,
        NgClass,
        TranslateModule,
        NgOptimizedImage
    ],
    templateUrl: './nav-list.component.html',
    styles: ``
})
export class NavListComponent implements OnInit{
  show = input.required<boolean>();
  collapsible = input.required<boolean>();
  menuList = signal<TMenu[]>([]);
  onCloseMenu = output<void>();
  onAction = output<TAccountAction>();
  account = inject(AccountService);
  accountService = inject(AccountService);
  #dialog = inject(MatDialog);

  ngOnInit() {
    const menuArr: TMenu[] = [
      {title: 'menu.main', urlPath: '/', id: 'main-url-v1'},
      {title: 'menu.faq', urlPath: '/faq', id: 'faq-url-v1'},
      {title: 'menu.news', urlPath: '/news', id: 'news-url-v1'},
    ];
    this.menuList.set(menuArr);
  }

  async showLogoutDialog() {
    const action = await openLogoutDialog(this.#dialog);

    if (!action) {
      return;
    }

    await this.logout();
  }

  async logout(): Promise<void> {
    await this.accountService.logout('exit');
  }

  closeMenu(): void {
    this.onCloseMenu.emit();
  }

  accountAction(logout: TAccountAction) {
    this.onAction.emit(logout);
    this.onCloseMenu.emit();
  }
}
